import { ClassAttributes, createElement, useContext } from 'react';
import { ScrollContainer } from 'react-router-scroll-4';

import { context as StateContext } from '../context/state';
import Screen from '../screen/SigningInScreen';

type Props = ClassAttributes<HTMLElement> & {
  className?: string;
};

const SigningInScreenConnected = ({ className }: Props) => {
  const state = useContext(StateContext);
  return !state.fatalError && !state.authentication.signedInUser && state.authentication.fetching === 0 ? (
    <ScrollContainer scrollKey="signing_in_screen">
      <Screen className={className} />
    </ScrollContainer>
  ) : null;
};

export default SigningInScreenConnected;
